import styled from 'styled-components';

export const FilterContainer = styled.div`
  padding: 12px 24px;
  border-bottom: 1px solid var(--mid-gray-drawer);
`;

export const SidePanelContainer = styled.div`
  .SidePanel__close-modal {
    font-size: 24px;
  }

  & > div {
    padding-left: 0;
    width: 360px;
    right: 0;
    left: unset;
    background: transparent;
  }
`;

export const OverLay = styled.div`
  background: var(--box-shadow);
  position: fixed;
  width: inherit;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
`;

export const FilterContainerOverLay = styled.div`
  background: transparent;
`;

export const FiltersContainer = styled.div`
  padding-bottom: 180px;

  form & > div > div > div {
    span,
    i {
      color: var(--luft-primary);
      flex-grow: unset;
      font-weight: bold;
      font-size: 14px;
      line-height: 18px;
    }
  }

  .DrawerFilters__action-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 18px 24px;
    background-color: white;
    z-index: 1;

    button {
      width: 100%;
      z-index: 1;
    }
  }
`;
